import { useEffect } from "react";
import { PhoneCall } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import { BOOKING_URL, CONTACT } from "@/data";

const API = process.env.REACT_APP_BACKEND_URL;

const CALENDLY_EMBED = `${BOOKING_URL}?hide_gdpr_banner=1&background_color=0a0a0b&text_color=ffffff&primary_color=d4af37`;

export default function BookCallPage() {
  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin.includes("calendly.com") && e.data?.event === "calendly.event_scheduled") {
        fetch(`${API}/api/bookings`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            event_uri: e.data?.payload?.event?.uri || null,
            invitee_uri: e.data?.payload?.invitee?.uri || null,
          }),
        }).catch(() => {});
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <>
      <PageHeader
        overline="Schedule a Conversation"
        title="Book a"
        accent="call."
        subtitle="Pick a time that works for your family. We'll review your protection needs, answer every question, and prepare your free quote — no pressure, ever."
      />

      <section className="relative pb-24 md:pb-32">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="rounded-3xl border border-[#bf953f]/25 overflow-hidden bg-[#0a192f] shadow-[0_0_60px_rgba(191,149,63,0.12)]">
              <iframe
                title="Schedule a call with Heritage Family Protection Agency"
                data-testid="booking-calendar"
                src={CALENDLY_EMBED}
                className="w-full h-[760px] md:h-[820px] border-0"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
              <p className="font-body font-light text-sm md:text-base text-white/55">
                Trouble booking, or need us sooner?
              </p>
              <a
                href={CONTACT.phoneHref}
                data-testid="booking-call-btn"
                className="inline-flex items-center gap-2 rounded-full border border-[#bf953f]/40 px-6 py-3 font-body text-sm tracking-wide text-[#fcf6ba] hover:border-[#d4af37] transition-colors duration-300"
              >
                <PhoneCall size={15} />
                {CONTACT.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
